import Button from 'components/_core/Button';
import Modal from 'components/_core/Modal';
import Text from 'components/_core/Text';

import locales from './locales';

type DuplicateTransfersModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onCancel: () => void;
};

const DuplicateTransfersModal = ({
  isOpen,
  onCancel,
  onClose,
  onConfirm,
}: DuplicateTransfersModalProps) => (
  <Modal isOpen={isOpen} onClose={onClose}>
    <Modal.Header />
    <Modal.Body>
      <Modal.Title>{locales.title}</Modal.Title>
      <Modal.Description>
        <Text>{locales.description}</Text>
      </Modal.Description>
    </Modal.Body>
    <Modal.Footer justifyContent="space-between">
      <Button onClick={onCancel} variant="inline-primary">
        {locales.cancel}
      </Button>
      <Button onClick={onConfirm}>{locales.cta}</Button>
    </Modal.Footer>
  </Modal>
);

export default DuplicateTransfersModal;
